import { Checkbox, Dropdown, Field, Input, makeStyles, Option, Text, tokens } from '@fluentui/react-components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

import { AppDetailsHeader } from '@tdp/common/components/AppDetailsHeader';
import { makeDocsLink } from '@tdp/common/constants';

import { createAppZoomHook } from '../../../hooks';
import { appFeaturesCommonStyles } from '../AppFeaturesCommon/appFeaturesCommon.styles';
import { createAppFeaturesFooter } from '../AppFeaturesCommon/AppFeaturesFooter';


const useStyles = makeStyles({
  section: {
    padding: tokens.spacingHorizontalL,
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingHorizontalM,
    maxWidth: '700px'
  }
});

const useMeetingExt = createAppZoomHook(app => app.meetingExtensionDefinition);
const Footer = createAppFeaturesFooter(app => [app.meetingExtensionDefinition]);

export const AppFeaturesMeetingExt: React.FC = () => {
  const navigate = useNavigate();
  const baseStyles = appFeaturesCommonStyles();
  const classes = useStyles();
  const intl = useIntl();
  const appId = useParams<{ appId: string }>().appId ?? '';
  const meetingExt = useMeetingExt(appId);

  const onStreamingChange = (val: boolean) => {
    meetingExt.update(t => {
      return {
        ...t,
        supportsStreaming: val
      }
    })
  }

  const onAnonymousChange = (val: boolean) => {
    meetingExt.update(t => {
      return {
        ...t,
        isAnonymousAccessAllowed: val
      }
    })
  }

  return (
    <div className={baseStyles.wrapper}>
      <div className={baseStyles.container}>
        <AppDetailsHeader
          onBackNavigation={() => { navigate(-1); }}
          showBackNavigation
          title={<FormattedMessage
            defaultMessage="Meeting extension"
            description={'Title for Meeting extension Section'}
          />}
          description={<FormattedMessage
            defaultMessage="Options for integrating your app with the Teams meeting experience, including the meeting stage and chat."
            description={'Description for Meeting extension Section'}
          />}
          link={<FormattedMessage
            defaultMessage="Learn more about Meeting extension"
            description={'Link to learn more about Meeting extension Section'}
          />}
          href={makeDocsLink("microsoftteams/platform/apps-in-teams-meetings/teams-apps-in-meetings")}
        />
        <br />
        <section className={classes.section}>
          <>
            <Field label={intl.formatMessage({ defaultMessage: "Select to allow the app access to requesting meeting to be streamed to its RTMP endpoint." })} />
            <Checkbox
              label={intl.formatMessage({ defaultMessage: "Supports streaming" })}
              checked={meetingExt.current?.supportsStreaming ?? false}
              onChange={(e, data) => { onStreamingChange(!!data.checked) }}
            />
          </>
        </section>
        <section className={classes.section}>
          <>
            <Field label={intl.formatMessage({ defaultMessage: "Select to allow the app to support access for anonymous users." })} />
            <Checkbox
              label={intl.formatMessage({ defaultMessage: "Supports anonymous guest users" })}
              checked={meetingExt.current?.isAnonymousAccessAllowed ?? false}
              onChange={(e, data) => { onAnonymousChange(!!data.checked) }}
            />
          </>
        </section>
      </div>
      <Footer />
    </div>
  )
};
